import { Injectable } from '@angular/core';
import { AuthResponseV2 } from '../models/auth-response.v2';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StorageManagerService {

    storageCache = new Map<string, string>();

    constructor() { }

    private getItem<T>(identifier: string): T {
        let value = this.storageCache.get(identifier);
        if (value === undefined) {
            value = localStorage.getItem(identifier);
            this.storageCache.set(identifier, value);
        }
        return value as unknown as T;
    }

    private setItem<T>(identifier: string, value: T) {
        this.storageCache.set(identifier, String(value));
        localStorage.setItem(identifier, String(value));
    }

    public get deviceIdentifier(): string | null {
        return this.getItem<string>(environment.host + '-deviceIdentifier');
    }

    public set deviceIdentifier(deviceIdentifier: string) {
        this.setItem<string>(environment.host + '-deviceIdentifier', deviceIdentifier)
    }

    public setPage(page) {
        localStorage.setItem('page', page)
    }

    public getToken() {
        return localStorage.getItem('public-token')
    }

    public setToken(token) {
        localStorage.setItem('public-token', token)
    }

    public removeToken() {
        localStorage.removeItem('public-token')
    }

    public getSubscription() {
        return JSON.parse(localStorage.getItem('public-subscription'))
    }

    public setSubscription(subscription) {
        localStorage.setItem('public-subscription', JSON.stringify(subscription))
    }

    public removeSubscription() {
        localStorage.removeItem('public-subscription')
    }

    public removeEmail() {
        localStorage.removeItem('public-email')
    }

    public setAvatarUrl(url) {
        localStorage.setItem('public-avatar-url', url)
    }

    public setString(key: string, value: string) {
        localStorage.setItem(key, value)
    }

    public getString(key: string) {
        return localStorage.getItem(key)
    }

    public removeString(key: string) {
        localStorage.removeItem(key)
    }

	public setExpiry(expiry: string): void {
		localStorage.setItem('expiry', expiry);
	}

	public getExpiry(): string {
		return localStorage.getItem('expiry');
	}

	public getDeviceHash(): string {
		return localStorage.getItem('device-hash');
	}

    public getAuthTokenV2(): AuthResponseV2 {
        const str = localStorage.getItem('auth-v2');
        if (str) {
            return JSON.parse(str);
        }
        return undefined;
    }

    public setAuthTokenV2(auth: AuthResponseV2): void {
        localStorage.setItem('auth-v2', JSON.stringify(auth))
    }

    public removeAuthTokenV2(): void {
        localStorage.removeItem('auth-v2');
    }
}
